import { SEARCH_AGGREGATES } from '@/utils/constants'
import { IParamsByUrlPartial } from '~types/search'

const buildSearchParams = (params: IParamsByUrlPartial) => {
  const {
    searchTerm = '',
    brands = [],
    categories = [],
    tags = [],
    availablePromotions = [],
    priceRanges = { gte: 0, lte: 0 },
    sort = '',
    operationalModels = [],
    currentPage = 1,
  } = params

  const searchParams = new URLSearchParams()
  searchParams.set('name', searchTerm)
  if (brands?.length > 0) {
    searchParams.set(SEARCH_AGGREGATES.brands, brands.join('~~'))
  }
  if (categories?.length > 0) {
    searchParams.set(SEARCH_AGGREGATES.categories, categories.join('~~'))
  }
  if (tags?.length > 0) {
    searchParams.set(SEARCH_AGGREGATES.tags, tags.join('~~'))
  }
  if (availablePromotions?.length > 0) {
    searchParams.set(
      SEARCH_AGGREGATES.availablePromotions,
      availablePromotions.length > 0 ? 'true' : 'false'
    )
  }
  if (operationalModels?.length > 0) {
    searchParams.set(
      SEARCH_AGGREGATES.operationalModels,
      operationalModels.join('~~')
    )
  }
  if (priceRanges?.gte !== 0 && priceRanges?.lte !== 0) {
    searchParams.set(
      SEARCH_AGGREGATES.priceRanges,
      `${priceRanges?.gte}-${priceRanges?.lte}`
    )
  }

  if (sort) {
    searchParams.set('sort', sort)
  }

  if (currentPage > 1) {
    searchParams.set('currentPage', currentPage.toString())
  }

  return searchParams.toString()
}
export default buildSearchParams
